<template>
  <div class="team-more">
    <div class="header flex justify-center items-center">
      <p class=" text-white text-font-32 font-weight-bold mt-20">精英团队</p>
    </div>
    <div class="body mx-auto " v-if="list1.length > 0 && list2.length > 0">
      <div
        @click="goPrev"
        class="arrow-item-left arrow-item flex justify-center items-center cursor-pointer"
      >
        <img src="../../assets/images/certfication/left.png" alt="" />
      </div>
      <div
        @click="goNext"
        class="arrow-item-right arrow-item flex justify-center items-center cursor-pointer"
      >
        <img src="../../assets/images/certfication/right.png" alt="" />
      </div>
      <div class="swiper-area">
        <swiper class="swiper " :options="swiperOption" ref="mySwiper1">
          <swiper-slide
            v-for="(item, index) in list1"
            :key="'swipe' + index"
            class="flex items-center"
          >
            <div
              class=" bg-image w-full bg-no-repeat bg-cover bg-center bg-top swiper-lazy"
              :data-background="item.image"
            >
              <div class="profile py-6">
                <div class="icon-image flex justify-center items-center">
                  <img src="../../assets/images/team/arrow-up.png" alt="" />
                </div>

                <div class="flex  items-end justify-center">
                  <p class=" text-font-18 text-white font-bold mr-3 ">
                    {{ item.name }}
                  </p>
                  <p class=" text-font-14  text-brighter">
                    {{ item.title }}
                  </p>
                </div>
                <div
                  class="pt-4 text-white px-6 profile-desc"
                  style="padding-bottom:6vh"
                >
                  <p
                    class=" text-center"
                    v-html="item.desc.replace(/(\;|\；)/g, '<br>')"
                  ></p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <swiper class="swiper " :options="swiperOption" ref="mySwiper2">
          <swiper-slide
            v-for="(item, index) in list2"
            :key="'swipe' + index"
            class="flex items-center"
          >
            <div
              class=" bg-image w-full bg-no-repeat bg-cover bg-center bg-top swiper-lazy"
              :data-background="item.image"
            >
              <div class="profile py-6">
                <div class="icon-image flex justify-center items-center">
                  <img src="../../assets/images/team/arrow-up.png" alt="" />
                </div>

                <div class="flex  items-end justify-center">
                  <p class=" text-font-18 text-white font-bold mr-3 ">
                    {{ item.name }}
                  </p>
                  <p class=" text-font-14  text-brighter">
                    {{ item.title }}
                  </p>
                </div>
                <div
                  class="pt-4 text-white px-6 profile-desc"
                  style="padding-bottom:6vh"
                >
                  <p
                    class=" text-center"
                    v-html="item.desc.replace(/(\;|\；)/g, '<br>')"
                  ></p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { getCategory } from '@/api'

export default {
  components: {
    swiper,
    swiperSlide
  },
  created() {
    getCategory(null, 3).then(ret => {
      if (ret.result) {
        let list = ret.result
          .map(c => {
            return {
              image: c.bg.md + '?x-oss-process=image/resize,p_30',
              name: c.name,
              title: c.title.zh,
              desc: c.content.zh
            }
          })
          .slice(4)
        let listLen = parseInt(list.length / 2)
        this.list1 = list.slice(0, listLen)
        this.list2 = list.slice(listLen)
      }
    })
  },
  data() {
    return {
      list1: [],
      list2: [],
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 1,
        loop: true,
        slidesPerGroup: 4,
        lazy: true,

        autoplay: {
          delay: 8000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        }
      }
    }
  },
  computed: {
    swiper1() {
      return this.$refs.mySwiper1.swiper
    },
    swiper2() {
      return this.$refs.mySwiper2.swiper
    }
  },
  methods: {
    goNext() {
      this.swiper1.slideNext()
      this.swiper2.slideNext()
    },
    goPrev() {
      this.swiper1.slidePrev()
      this.swiper2.slidePrev()
    }
  }
}
</script>

<style lang="less">
@slideHeight: 60vh;
.team-more {
  background-color: rgb(48, 49, 50);
  min-width: 1200px;
  margin: auto;
  img {
    max-width: 100%;
    height: auto;
  }

  .header {
    width: 100%;
    height: 200px;
    background: url('../../assets/images/company-profile/顶部图片.jpg');
    background-size: cover;
    background-position: center;
  }
  .body {
    width: 80vw;
    margin: auto;
    height: calc(100vh - 200px);
    position: relative;
    .arrow-item {
      position: absolute;
      z-index: 999;
      top: 50%;
      transform: translateY(-50%);
      width: 5vw;
      height: 19vh;
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 3px;
      img {
        width: 2.5vw;
      }
    }
    .arrow-item-left {
      left: -7vw;
    }
    .arrow-item-right {
      right: -7vw;
    }
    // min-height: 60vh;
    .swiper {
      height: calc(50vh - 100px);
      width: 100%;
      .swiper-slide {
        height: calc(50vh - 100px);
        .bg-image {
          // width: 25vw;
          height: 100%;
          transition: all ease 0.3s;
          position: relative;
          &:hover {
            .profile > .icon-image {
              transform: rotate(180deg);
            }
            .profile > .profile-desc {
              // transform: translateY(0);
              display: block;
              // opacity: 1;
            }
          }
          .profile {
            position: absolute;
            bottom: 0px;
            background-color: rgba(0, 0, 0, 0.58);
            width: 100%;
            // min-height: 60px;

            .icon-image {
              position: absolute;
              width: 40px;
              height: 40px;
              left: 50%;
              top: -20px;
              margin-left: -20px;
              transition: all ease 0.3s;

              padding: 4px;
              border: 4px solid rgba(255, 255, 255, 0.1);
              border-radius: 100%;
            }
            .profile-desc {
              transition: all ease 0.3s;
              transform-origin: bottom;
              // transform: scaleY(0);
              // transform: translateY(100%);
              // opacity: 0;
              display: none;
            }
          }
          &:hover {
            height: calc(50vh - 60px);
            box-shadow: -2px -1px 12px -2px rgba(0, 0, 0, 0.58);
          }
        }
      }
    }
  }
}
</style>
